// extracted by mini-css-extract-plugin
module.exports = {"root":"BaseLayout_root__1BMxs","mobile":"BaseLayout_mobile__3pwKU","fixed":"BaseLayout_fixed__1Zsl4","fixed2":"BaseLayout_fixed2__2Mumc"};